import { render, staticRenderFns } from "./addpredefined.vue?vue&type=template&id=4d6ebf8f&"
import script from "./addpredefined.vue?vue&type=script&lang=js&"
export * from "./addpredefined.vue?vue&type=script&lang=js&"
import style0 from "./addpredefined.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6ebf8f')) {
      api.createRecord('4d6ebf8f', component.options)
    } else {
      api.reload('4d6ebf8f', component.options)
    }
    module.hot.accept("./addpredefined.vue?vue&type=template&id=4d6ebf8f&", function () {
      api.rerender('4d6ebf8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/components/addpredefined.vue"
export default component.exports